import type { RouteRecordRaw } from 'vue-router';
import { PROMOTION_MANAGEMENT_ROUTE_NAME } from '@/consts';

// No `meta.i18n`: every string this screen renders belongs to the SetupPromotion partial,
// which is also mounted under /customer-checkout. A route-scoped bundle only loads for the
// route that declares it, so those keys live in the global bundle instead.
export const promotionManagementRoutes: RouteRecordRaw = {
  path: '/promotion-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true },
  children: [
    {
      name: PROMOTION_MANAGEMENT_ROUTE_NAME.PROMOTION_MANAGEMENT,
      path: '',
      component: () => import('./PromotionManagement.vue'),
    },
  ],
};
